<template>
    <div>
        <div class="row justify-content-center ">
            <div class="col-md-8 pt-3">
                <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Allergies</p>
            </div>
            <div class="col-md-4 pt-3 text-right pr-4">
                <a href="/my-health/allergies/edit" aria-label="My Allergies - Edit" class="color-sky-blue-3" v-if="als.length > 0">
                    Edit
                </a>
            </div>
        </div>
        <div class="row justify-content-center ">
            <div class="col-md-12">
                <div class="col-md-12 mb-2">
                    <a href="/my-health/allergies/add" class="btn btn-primary btn-sb">Add new allergy</a>
                </div>

                <ul class="list-group mb-3" v-if="als.length>0">
                    <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0" v-for="(a, key) in als" v-if="view_more || key < 4">
                        <div class="row">
                            <div class="col-md-9 sb-list-fitem-regular">
                                {{ a.all_sr ? a.all_srname : a.allergy_data.ald_name }}
                            </div>
                            <div class="col-md-3 text-right sb-list-sitem">
                                <a href="#" class="text-danger" @click="deleteAlById(a)" :aria-label="((a.all_sr ? a.all_srname : a.allergy_data.ald_name) + ' - Remove')">
                                    Remove
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
                <div v-if="als.length>4" class="text-right mb-3 mr-3">
                    <a href="#" @click.prevent="view_more=!view_more" v-if="view_more" aria-label="View Less Allergies">View Less</a>
                    <a href="#" @click.prevent="view_more=!view_more" v-else aria-label="View More Allergies">View More</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['allergies'],
    mounted() {
        this.listAl(true);
    },
    data() {
        return {
            route: '/api/allergies',
            als: [],
            view_more: false
        }
    },
    methods: {
        listAl(fromProp = false) {
            if (fromProp) {
                this.als = this.allergies;
            } else {
                this.$http.get(this.route)
                    .then(function (response) {
                        this.als = response.data;
                    }, (response) => {
                        this._handleErrors(response.data, '#al-form')
                    })
            }

        },
        deleteAlById(al) {
            if (confirm('Do you really want to delete this allergy?')) {
                this.$http.delete(this.route + '/' + al.all_id)
                    .then(function (response) {
                        this.listAl();
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Allergy was deleted!'
                        });
                        this.showModal = false;
                    }, (response) => {
                        this._handleErrors(response.data, '#al-form')
                    })
            }
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        }
    }

}
</script>
